<template>
  <div class="md-layout">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loadingTickets"></md-progress-bar>
    <div class="md-layout-item md-size-100" v-else>
      <div class="md-layout-item md-size-100">
        <span class="md-title">{{$t('ticket.statistics.title')}}</span>
      </div>
      <md-toolbar class="md-toolbar-section-end md-transparent toolbar" md-elevation="0">
        <md-field class="md-layout-item md-size-20">
          <label>{{$t('ticket.statistics.search.season')}}</label>
          <md-select v-model="searchModel.seasonId" name="season" id="season">
            <md-option v-for="season in listSeasons" :value="season.id" :key="season.id">
              {{season.name}}
            </md-option>
          </md-select>
        </md-field>
        <md-field class="md-layout-item md-size-20">
          <label>{{$t('ticket.statistics.search.matchday')}}</label>
          <md-input type="number" v-model="searchModel.matchday" name="matchday" id="matchday"></md-input>
        </md-field>
        <div class="md-layout-item md-size-10">
          <md-button :disabled="searchModel.seasonId == null && searchModel.matchday == null && !searchTickets" class="md-info" @click="search()">
            <span v-if="!searchTickets">{{$t('ticket.statistics.search.title')}}</span>
            <md-progress-spinner v-else class="md-info" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </md-button>
        </div>
      </md-toolbar>

      <div class="md-layout-item md-size-100" v-if="statistics.gamesTotal > 0">
        <div class="container md-layout">
          <div class="md-layout-item md-size-30">
            <md-card>
              <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                  <md-icon>local_activity</md-icon>
                </div>
                <h4 class="title">{{ $t("ticket.statistics.generalInfo") }}</h4>
              </md-card-header>
              <md-card-content>
                <md-list>
                  <md-list-item>
                    <span>
                      <strong>Total de partidos : </strong> {{statistics.gamesTotal}}
                    </span>
                  </md-list-item>
                  <md-list-item>
                    <span>
                      <strong>Total de tickets : </strong> {{statistics.tickets.total}} <i>(Utilizados: {{statistics.tickets.used}})</i>
                    </span>
                  </md-list-item>
                </md-list>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-size-70">
            <md-card>
              <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                  <md-icon>local_activity</md-icon>
                </div>
                <h4 class="title">{{ $t("ticket.statistics.detail") }}</h4>
              </md-card-header>
              <md-card-content>
                <md-table v-model="statistics.details" table-header-color="blue">
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell :md-label="$t('ticket.statistics.table.detail')">{{ item.description }}</md-table-cell>
                    <md-table-cell :md-label="$t('ticket.statistics.table.game')">{{ item.game }}</md-table-cell>
                    <md-table-cell :md-label="$t('ticket.statistics.table.team')">{{ item.team }}</md-table-cell>
                    <md-table-cell :md-label="$t('ticket.statistics.table.size')">{{ item.size }}</md-table-cell>
                    <md-table-cell :md-label="$t('ticket.statistics.table.used')">{{ item.used }}</md-table-cell>
                    <md-table-cell>
                      <router-link :to="`/ticketera/detail/ticket/${item.id}`">
                        {{$t('ticket.statistics.table.view')}}
                      </router-link>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>

      <md-empty-state
        v-if="statistics.gamesTotal == 0"
        md-icon="local_activity"
        md-label="Sin estadisticas"
        md-description="El partido seleccionado no tiene estadistica sobre los tickets">
      </md-empty-state>
      <div class="md-layout-item md-size-100 md-alignment-center-center">
      </div>


    </div>


  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loadingTickets: true,
      searchTickets: false,
      searchModel: {
        seasonId: null,
        matchday: null
      },
      statistics: {
        details: [],
        gamesTotal: 0,
        tickets: {total: 0, used: 0}
      }
    }
  },
  computed: {
    ...mapState({
      listSeasons: state => state.StuffModule.seasons
    })
  },
  async mounted() {
    await this.$store.dispatch("seasonsGet")
    this.loadingTickets = false
  },
  methods: {
    async search() {
      this.searchTickets = true
      const response = await this.$store.dispatch("ticketMatchdayReport", this.searchModel)
      if (response.status == 200) {
        this.statistics = response.data
      }
      this.searchTickets = false
    }
  }
}
</script>

<style lang="scss">
  .toolbar {
    .md-field {
      margin: 0 8px;
    }
  }
</style>